<TreeSelect ref="treeSelect" style="line-height: 1;" :load-options="loadOptions" :auto-load-root-options="false"
    :multiple="multiple" :value="value" @input="handleValueChanged" :options="data">
    <label slot="option-label" slot-scope="{node}">{{node.raw.title}}</label>
    <span slot="value-label" slot-scope="{node}">{{(!(node.raw.parentName||'')?'':(node.raw.parentName||'')+'/')+(node.raw.title||'')}}</span>
</TreeSelect>